import { Component, Inject, LOCALE_ID, NgZone, PLATFORM_ID } from '@angular/core';
import { filter, mergeMap, switchMap, take, takeUntil } from 'rxjs/operators';
import { LoginStatusService } from 'src/app/services/auth/login/login-status.service';
import { Tournament } from 'src/app/services/tournaments/tournaments.models';
import { LoggedStatus } from 'src/app/services/auth/login/login.models';
import { missionsTrx, tournamentsTrx } from 'src/app/router-translation.labels';
import { ActivatedRoute, Router } from '@angular/router';
import { TournamentDetailsService } from 'src/app/services/tournaments/tournament-details.service';
import { DetectDeviceService } from 'src/app/services/utils/detect-device.service';
import { isPlatformServer } from '@angular/common';
import { MissionService } from 'src/app/services/missions/mission.service';
import { Mission } from 'src/app/services/missions/missions.models';
import { MissionDetailsService } from 'src/app/services/missions/mission-details.service';
import { SwiperOptions } from 'swiper';
import { UserCampaignService } from 'src/app/services/campaigns/campaign.service';
import { BaseComponent } from '../../base/base.component';

@Component({
  selector: 'app-reactivation-category',
  templateUrl: './reactivation-category.component.html',
  styleUrls: ['./reactivation-category.component.scss']
})
export class ReactivationCategoryComponent extends BaseComponent{
 infoData: any;
 infoDataIndex: number;
 

  constructor(
    public userCampaignService: UserCampaignService,
    public detectDeviceService: DetectDeviceService,
    public route: ActivatedRoute,
    public router: Router

  ) {
    super();
  }

  ngOnInit(): void {

    this.route.params.subscribe(data=>{

      this.infoDataIndex = data.id
    })
    this.route.params
    .pipe(
      switchMap((params) => {
        const ActiveId = params['id'];
        console.log(params)
        return this.userCampaignService.getActiveInfo()
      }
      ),
      takeUntil(this.unsubscribe))

    .subscribe((data) => {
      this.infoData = data
    })
  }

  ctaRoute(){
    this.router.navigate(['/'+this.infoData[this.infoDataIndex].ctaLink])
  }

  closeDialog(){
    this.router.navigate(['/'])
  }


}
